import { render, staticRenderFns } from "./studies.vue?vue&type=template&id=bfdd45bc"
import script from "./studies.vue?vue&type=script&lang=js"
export * from "./studies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports